import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPlayCircleFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842854 10.1217 0 8 0ZM12.2554 8.51086L5.39829 11.9394C5.31115 11.983 5.21432 12.0041 5.11701 11.9997C5.01969 11.9953 4.92512 11.9661 4.84227 11.9148C4.75942 11.8636 4.69105 11.792 4.64365 11.7069C4.59625 11.6218 4.57139 11.526 4.57143 11.4286V4.57143C4.57148 4.47406 4.59641 4.37832 4.64386 4.2933C4.6913 4.20827 4.75968 4.13678 4.84251 4.0856C4.92535 4.03443 5.01988 4.00526 5.11715 4.00088C5.21442 3.9965 5.31119 4.01705 5.39829 4.06057L12.2554 7.48914C12.3502 7.53665 12.4299 7.60959 12.4856 7.69981C12.5413 7.79003 12.5708 7.89397 12.5708 8C12.5708 8.10603 12.5413 8.20996 12.4856 8.30019C12.4299 8.3904 12.3502 8.46335 12.2554 8.51086Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgPlayCircleFilled)
const IconSvgPlayCircleFilled = createIcon(ForwardRef, 'SvgPlayCircleFilled')
export default IconSvgPlayCircleFilled
